import { Component } from '@angular/core';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';

@Component({
  selector: 'mg-version-news',
  templateUrl: './version-news.component.html',
  styleUrls: ['./version-news.component.scss'],
  standalone: true,
  imports: [IconComponent]
})
export class VersionNewsComponent {

}
